import { render, staticRenderFns } from "./LinkTile.vue?vue&type=template&id=700cfd80"
import script from "./LinkTile.vue?vue&type=script&lang=js"
export * from "./LinkTile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports